import { Box, Container, Typography, Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { psiTokens } from '../theme/psiTheme';
import ContactForm from './ContactForm';

// Shared by the Home page's inline Contact section and the standalone
// /contact page, so the layout and behavior only exist in one place.
// The heading lives in the same column as the form so the grid's
// alignItems="center" keeps the form vertically centered against it.
export default function ContactSection({
  id,
  backgroundColor = psiTokens.background.secondary,
  eyebrow = 'Contact',
  title = "Let's start a conversation.",
  description = "PSI works with organizations seeking to develop real, lasting capacity to solve problems. Whether it's a one-time session or an ongoing program, the conversation starts here.",
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box id={id} sx={{ backgroundColor, py: isMobile ? 6 : 8 }}>
      <Container maxWidth="xl">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: '40px',
                height: '3px',
                background: `linear-gradient(90deg, ${psiTokens.primary.dark}, ${psiTokens.primary.light})`,
                borderRadius: '2px',
                mb: 2,
              }}
            />
            <Typography
              sx={{
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.15em',
                textTransform: 'uppercase',
                color: psiTokens.primary.light,
                mb: 2,
              }}
            >
              {eyebrow}
            </Typography>
            <Typography variant="h2" sx={{ color: psiTokens.text.primary, fontWeight: 700, mb: 2 }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: '15px', color: psiTokens.text.tertiary, lineHeight: 1.8, mb: 4, maxWidth: '520px' }}>
              {description}
            </Typography>

            <Stack spacing={2}>
              <Stack direction="row" alignItems="baseline" spacing={1.5} flexWrap="wrap">
                <Typography
                  sx={{
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '0.15em',
                    textTransform: 'uppercase',
                    color: psiTokens.primary.light,
                  }}
                >
                  Email
                </Typography>
                <Typography
                  component="a"
                  href="mailto:fidel.gutierrez@psintel.com"
                  sx={{
                    fontSize: '13px',
                    fontWeight: 400,
                    color: psiTokens.text.secondary,
                    textDecoration: 'none',
                    '&:hover': { color: psiTokens.primary.light },
                  }}
                >
                  fidel.gutierrez@psintel.com
                </Typography>
              </Stack>

              <Stack direction="row" alignItems="baseline" spacing={1.5} flexWrap="wrap">
                <Typography
                  sx={{
                    fontSize: '11px',
                    fontWeight: 700,
                    letterSpacing: '0.15em',
                    textTransform: 'uppercase',
                    color: psiTokens.primary.light,
                  }}
                >
                  LinkedIn
                </Typography>
                <Typography
                  component="a"
                  href="https://linkedin.com/in/fidel-gutierrez-a145571/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: '13px',
                    fontWeight: 400,
                    color: psiTokens.text.secondary,
                    textDecoration: 'none',
                    '&:hover': { color: psiTokens.primary.light },
                  }}
                >
                  linkedin.com/in/fidel-gutierrez-a145571/
                </Typography>
              </Stack>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6}>
            <ContactForm />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
